<div class="common-grid-wrapper" [ngClass]="{ 'lang-ar': isRTL, 'lang-en': !isRTL }">
  <!-- Loading State -->
  @if (loading) {
    <div class="loading-state">
      <div class="spinner"></div>
      <p>{{ 'common.loading' | translate }}</p>
    </div>
  }

  <!-- Empty State -->
  @if (!loading && rows.length === 0) {
    <div class="empty-state">
      <i [ngClass]="'bi ' + emptyStateIcon"></i>
      <p>{{ emptyStateMessageKey | translate }}</p>
    </div>
  }

  <!-- Table -->
  @if (!loading && rows.length > 0) {
    <div class="table-responsive">
      <table class="common-table">
        <thead>
          <tr>
            @for (column of columns; track column) {
              <th>
                {{ column.translationKey | translate }}
              </th>
            }
            @if (actions.length > 0) {
              <th>{{ 'common.actions' | translate }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track trackByRowId($index, row)) {
            <tr
              class="data-row"
              [class.row-interactive]="enableRowClick"
              [ngClass]="getRowCssClass(row)"
              (click)="onRowClick($event, row)">
              <!-- Dynamic Columns -->
              @for (column of columns; track column) {
                <td [ngClass]="'cell-' + column.key">
                  @switch (column.type) {
                    <!-- Badge Type (for status, badges, etc.) -->
                    @case ('badge') {
                      <span [ngClass]="'badge ' + getStatusClass(row[column.key])">
                        {{ 'statuses.' + row[column.key] | translate }}
                      </span>
                    }
                    <!-- Date Type -->
                    @case ('date') {
                      <span>
                        {{ getCellValue(row, column.key) }}
                      </span>
                    }
                    <!-- Custom Type -->
                    @case ('custom') {
                      <span [innerHTML]="getCellValue(row, column.key)"></span>
                    }
                    <!-- Default Text Type -->
                    @default {
                      <span>{{ getCellValue(row, column.key) }}</span>
                    }
                  }
                </td>
              }
              <!-- Actions -->
              @if (actions.length > 0) {
                <td class="cell-actions">
                  <div class="action-buttons">
                    @for (action of actions; track action) {
                      <button
                        [hidden]="!shouldShowAction(action, row)"
                        (click)="onActionClick(action, row)"
                        [class]="'btn-action btn-' + action.type"
                        [title]="action.label | translate"
                        type="button"
                        aria-label="{{ action.label | translate }}"
                        >
                        @if (action.icon) {
                          <i [ngClass]="'bi ' + action.icon"></i>
                        }
                        <span class="action-label">{{ action.label | translate }}</span>
                      </button>
                    }
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <!-- Pagination -->
  @if (showPagination && totalRecords > 0) {
    <div class="pagination-container">
      <div class="pagination-info">
        <label for="pageSize" class="items-per-page-label">
          {{ 'common.itemsPerPage' | translate }}:
        </label>
        <select
          id="pageSize"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange(pageSize)"
          class="page-size-selector"
          [disabled]="loading">
          @for (size of pageSizeOptions; track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
      </div>
      <div class="pagination-controls">
        <!-- Previous Button -->
        <button
          class="btn btn-pagination btn-prev"
          (click)="onPageChange(currentPage - 1)"
          [disabled]="!hasPreviousPage() || loading"
          type="button"
          aria-label="{{ 'common.previous' | translate }}">
          <i class="bi bi-chevron-left"></i>
        </button>
        <!-- Page Numbers -->
        <div class="page-numbers">
          @for (pageNum of getPageNumbers(); track pageNum) {
            <button
              type="button"
              class="btn btn-page"
              [disabled]="pageNum === -1 || loading"
              [class.active]="pageNum === currentPage"
              [class.ellipsis]="pageNum === -1"
              (click)="onPageChange(pageNum)"
              [attr.aria-label]="pageNum === -1 ? '...' : 'Page ' + (pageNum + 1)">
              {{ pageNum === -1 ? '...' : pageNum + 1 }}
            </button>
          }
        </div>
        <!-- Next Button -->
        <button
          class="btn btn-pagination btn-next"
          (click)="onPageChange(currentPage + 1)"
          [disabled]="!hasNextPage() || loading"
          type="button"
          aria-label="{{ 'common.next' | translate }}">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
      <div class="pagination-summary">
        <span class="record-count">
          {{ (currentPage * pageSize + 1) }} - {{ Math.min((currentPage + 1) * pageSize, totalRecords) }}
          {{ 'common.of' | translate }} {{ totalRecords }}
        </span>
      </div>
    </div>
  }
